import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import {
  CasesSendReportV1ActiveCaseListContainerSendReportCaseV1Document,
  CasesSendReportV1ActiveCaseListContainerSendReportCaseV1CurrentDocument,
  CasesSendReportV1RelatedCasesTabContainerSendReportCaseV1Document,
  CasesSendReportRelatedCasesTabContainerArchivedSendReportCaseSummaryDocument,
} from "../../../../../../generated";
import { RelatedCasesTab } from "./related-cases-tab";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";

interface RelatedCasesTabContainerProps {
  caseId: string;
  isArchived?: boolean;
}

export const RelatedCasesTabContainer: React.FC<RelatedCasesTabContainerProps> = (
  props
) => {
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [applicantId, setApplicantId] = useState<string | null>(null);

  const { data: caseData, loading: caseLoading, error: caseError } = useQuery(
    CasesSendReportV1RelatedCasesTabContainerSendReportCaseV1Document,
    {
      variables: {
        sendReportCaseV1Id: props.caseId,
      },
      skip: props.isArchived,
      context: {
        headers: {
          "cache-enabled": "true",
        },
      },
    }
  );

  const {
    loading: archivedApplicantLoading,
    data: archivedApplicantData,
    error: archivedApplicantError
  } = useQuery(CasesSendReportRelatedCasesTabContainerArchivedSendReportCaseSummaryDocument, {
    variables: {
      archivedSendReportCaseSummaryId: props.caseId
    },
    skip: !props.isArchived
  });


  const { loading: applicantLoading, data: applicantData, error: applicantError } = useQuery(
    CasesSendReportV1ActiveCaseListContainerSendReportCaseV1Document,
    {
      variables: {
        sendReportCaseV1Id: props.caseId,
      },
      skip: props.isArchived,
      context: {
        headers: {
          "cache-enabled": "true",
        },
      },
    }
  );

  const { loading } = useQuery(
    CasesSendReportV1ActiveCaseListContainerSendReportCaseV1CurrentDocument,
    {
      variables: {
        applicantId: selectedId,
      },
      skip: !selectedId,
    }
  );

  type MenuInfo = {
    key: React.Key;
  };

  useEffect(() => {
    if (props.isArchived) {
      setApplicantId(archivedApplicantData?.archivedSendReportCaseSummary?.applicant?.id ?? null);
    } else {
      setApplicantId(applicantData?.sendReportCaseV1?.applicant?.id ?? null);
    }
  }, [props.isArchived, archivedApplicantData, applicantData]);
  
  const handleMenuClick = (e: MenuInfo) => {
    if (e.key === "credential-verification") {
      setSelectedId(applicantId);
    } else {
      setSelectedId(null);
    }
  };

  const disabled = caseData?.sendReportCaseV1?.isCurrentUserAssigned || props.isArchived

  return (
    <ComponentQueryLoader
      loading={loading || caseLoading || applicantLoading || archivedApplicantLoading}
      error={caseError || applicantError || archivedApplicantError}
      hasData={caseData || archivedApplicantData}
      hasDataComponent={
        <RelatedCasesTab
        setDisabled={()=>{}}
          handleMenuClick={handleMenuClick}
          caseId={props.caseId}
          selectedId={selectedId}
          applicantId={applicantId as string}
          disabled={disabled as boolean}
        />
      }
    />
  );
};
